import { FCWithChildren } from '@types';
import React from 'react';
import { FaWifi } from 'react-icons/fa';
import { MdWifiLock } from 'react-icons/md';
import { Button, InputSectionGroup } from '@components';
import { useToasts } from 'react-toast-notifications';
import useLayoutContext from '@hooks/useLayoutContext';

type PskBodyProps = {
  preWiredKey?: string;
};

const PskBody: FCWithChildren<PskBodyProps> = ({ preWiredKey }) => {
  const { ssid, startHereSsid } = useLayoutContext();
  const { addToast } = useToasts();

  return (
    <div className="flex gap-10 items-start">
      <div className="min-w-0 space-y-4 text-gray-700 dark:text-gray-300">
        <div className="flex gap-4 items-baseline">
          <span className="shrink-0 text-gray-400 dark:text-gray-500">1</span>
          <p>
            Open Wifi Settings <FaWifi className="text-2xl inline" />
          </p>
        </div>
        <div className="flex gap-4 items-baseline">
          <span className="shrink-0 text-gray-400 dark:text-gray-500">2</span>
          <div className="w-full">
            <p>Select the network</p>
            <InputSectionGroup className="mt-2">
              <InputSectionGroup.Item>
                <div className="input-section-group__field">
                  <label className="flex gap-4 items-center">
                    <div className="bg-blue-500 rounded-full p-2">
                      <FaWifi className="text-2xl inline" />
                    </div>
                    {ssid}
                  </label>
                </div>
              </InputSectionGroup.Item>
            </InputSectionGroup>
          </div>
        </div>
        <div className="flex gap-4 items-baseline">
          <span className="shrink-0 text-gray-400 dark:text-gray-500">3</span>
          <div className="w-full">
            <p>Enter your WiFi Password or Security Key</p>
            <div className="flex gap-2 items-center mt-2">
              <InputSectionGroup>
                <InputSectionGroup.Item>
                  <div className="input-section-group__field">
                    <label className="flex gap-4 items-center">{preWiredKey}</label>
                  </div>
                </InputSectionGroup.Item>
              </InputSectionGroup>
              <div className="flex-1">
                <Button
                  onClick={() => {
                    navigator.clipboard.writeText(preWiredKey || '');
                    addToast('Wi-Fi password copied', { appearance: 'success' });
                  }}
                  size="small"
                >
                  Copy
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-4 items-baseline">
          <span className="shrink-0 text-gray-400 dark:text-gray-500">4</span>
          <p>
            Forget the <span className="text-xl font-bold">{startHereSsid}</span> network if you had
            connected to it previously
          </p>
        </div>
        <div className="pt-2 text-sm text-gray-500 dark:text-gray-400 space-y-1">
          <p className="font-semibold">Note:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>Select option to Auto reconnect to the {ssid} network</li>
            <li>For Wired connections, click Add Device to add your Wired MAC address</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PskBody;
